import * as React from 'react'

import { Icon } from '@factorialco/deprecated-design-system'
import classNames from 'classnames/bind'
import range from 'lodash/range'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Store from '../Store'
import styles from './index.module.scss'

interface Props {
  store: Store
  search: string
  onSearch: (event: React.ChangeEvent<HTMLInputElement>) => void
}
interface DayCellProps {
  store: Store
  day: number
}

const cx = classNames.bind(styles)

const DayCell = observer(function DayCell({ store, day }: DayCellProps) {
  const dayLeaf = store.days[day]
  const cellClassName = cx('dayCell', dayLeaf?.classes)

  return (
    <th className={cellClassName}>
      <div className={styles.content}>{day + 1}</div>
    </th>
  )
})

const TableHeader = observer(function TableHeader({ store, search, onSearch }: Props) {
  return (
    <thead>
      <tr>
        <th className={styles.searchCell}>
          <Icon.Medium icon="search" />
          <input
            type="text"
            className={styles.search}
            placeholder={i18n.t('common.search_employees')}
            onChange={onSearch}
            value={search || ''}
          />
        </th>
        {range(store.daysInMonth).map((day) => (
          <DayCell store={store} day={day} key={day} />
        ))}
      </tr>
    </thead>
  )
})

export default TableHeader
